var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('auth-provider',{attrs:{"init-action":"users/auth/initialReceive"}},[_c('router-view')],1),_c('trigger-review-modal'),_c('modals-container'),_c('v-dialog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }